<template>
    <div :class="classList">
        <slot></slot>
    </div>
</template>

<script>
    import AlignmentClassesMixin from "../../mixins/AlignmentClassesMixin";

    export default {
        mixins: [AlignmentClassesMixin],
        props: {
            reversed: {
                type: Boolean,
                default: false
            },
            wrapReversed: {
                type: Boolean,
                default: false
            },
            noWrap: {
                type: Boolean,
                default: false
            }
        },
        computed: {
            classList() {
                return Object.assign({
                    'flex': true,
                    'flex-row': !this.reversed,
                    'flex-row-reverse': this.reversed,
                    'flex-wrap': !this.noWrap && !this.wrapReversed,
                    'flex-wrap-reverse': this.wrapReversed,
                    'w-full': true
                }, this.alignmentClasses);
            }
        }
    };
</script>